export const MAX_TITLE_LENGTH = 50;
export const MAX_DESCRIPTION_LENGTH = 5000;
